import classes from './input.module.css'

const Input = {
  classNames: {
    input: classes.input,
  },
}

export const InputWrapper = {
  classNames: {
    label: classes['wrapper-label'],
  },
}

export default Input
